import React from 'react';
import { Backdrop, Spinner } from '@/kaya';
import Table from '../table/Table';
import { column } from '@/config/userActivityTable.config';
import { songTypes } from '@/types';

import styles from './SongLogTable.module.scss';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  data: songTypes.Log[];
  isLoading?: boolean;
}

const SongLogTable = (props: Props) => {
  const { visible, setVisible, data, isLoading } = props;

  return visible ? (
    <div>
      <Backdrop visible={visible} setVisible={setVisible} />
      <div className={styles.tableContainer}>
        {isLoading ? (
          <div className={styles.loaderContianer}>
            <Spinner />
          </div>
        ) : (
          <div className={styles.table}>
            <Table columns={column} rows={data} disableActions />
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default SongLogTable;
